/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    function copyToClipboard(textToCopy) {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard api method'
            return navigator.clipboard.writeText(textToCopy);
        } else {
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                // here the magic happens
                document.execCommand('copy') ? res() : rej();
                textArea.remove();
            });
        }
    }


    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();
        let title = $(e.target).find('[type=submit]').data('title') || 'Are you sure you want to delete this item?';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    }).on('submit', 'form[name=duplicate-item]', function(e) {
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to duplicate this item?',
                showCancelButton: true,
                confirmButtonText: 'Confirm Duplicate',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        }).on('submit', 'form[name=export-item]', function(e) {
        e.preventDefault();
        this.submit()
        enableSubmitButtons($(this));

    }).on('submit', 'form[name=copy-item]', function(e) {
        e.preventDefault();
        let action = $(e.target).find('[type=submit]').data('title');

        copyToClipboard(action)
            .then(() => {
                Swal.fire('Link copied !', '', 'success')
                enableSubmitButtons($(this));
            })
            .catch(() => {
                Swal.fire('Link is\'t copied !', '', 'info')
                enableSubmitButtons($(this));
            });
    }).on('submit', 'form[name=export-item]', function(e) {
        e.preventDefault();
        this.submit()
        enableSubmitButtons($(this));

    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        }).on('click', 'button.confirm-item[type=submit]', function (e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                $(this).closest('form').submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    }).on('click', 'form[name=confirm-survey-en]',  function (e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you wish to submit your survey response?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                $(this).closest('form').submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    }).on('click', 'form[name=confirm-survey-fr]',  function (e) {
        e.preventDefault();

        Swal.fire({
            title: "Êtes-vous sûr de vouloir soumettre votre réponse à l'enquête ?",
            showCancelButton: true,
            confirmButtonText: 'Continuer',
            cancelButtonText: 'Annuler',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                $(this).closest('form').submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    }).on('click', 'form[name=confirm-survey-es]',  function (e) {
        e.preventDefault();

        Swal.fire({
            title: '¿Estás segura de que deseas enviar tu respuesta a la encuesta?',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                $(this).closest('form').submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    })
        .on('click', 'a[name=confirm-item-with-input]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Please enter the reason',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
            input: 'text',
        }).then((result, info) => {
            if (result.isConfirmed) {
                $('#reasonText').val(result.value);
                $('#reviewForm').submit();
            }
        }).catch(error => {
            Swal.showValidationMessage(
                `Request failed: ${error}`
            )
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }



        $('#extra').on('click',function (e){
            e.preventDefault();

            Swal.fire({
                title: "PETO"
            }).then();
        })

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    window.escapeRegExp = function (string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    window.replaceAll = function(str, find, replace) {
        return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    }
});
